import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import history from '~/services/history';
import { loadingDrawer } from '~/store/modules/drawer/actions';

function BlankPage() {
  const dispatch = useDispatch();

  const { navigations } = useSelector((state) => state.drawer);

  const handleRedirectToPage = useCallback(async () => {
    try {
      dispatch(loadingDrawer(true));

      const dash = navigations.find((nav) => nav.rotamenu === '/dashboard');
      if (dash) history.push('/dashboardvisaogeral');
    } catch (err) {
      console.error('Houve um erro ao redirecionar o usuário!');
    } finally {
      dispatch(loadingDrawer(false));
    }
  }, [navigations]);

  useEffect(() => {
    handleRedirectToPage();
  }, [navigations]);

  return <div />;
}

export default BlankPage;
